/**
 * Created by jacmai on 3/3/2017.
 */
define([
  "marionette",
  "modules/shared/adminMenu/template/adminMenuTemplate.html",
  "modules/shared/adminMenu/template/adminItemTemplate.html",
  "modules/shared/adminMenu/template/adminItemWithChildrenTemplate.html",
], function (
  Marionette,
  KbAdminMenuTemplate,
  KbAdminItemTemplate,
  KbAdminItemWIthChildrenTemplate,
) {
  var KbAdminMenuView = {};

  KbAdminMenuView.itemView = Marionette.CompositeView.extend({
    template: KbAdminItemTemplate,
    tagName: "li",
    initialize: function () {
      this.collection = this.model.get("children");
      // Can't access attributes with names that are reserved words from _.template
      this.model.set("isDefaultItem", this.model.get("default"));
      // Set proper template based on presence of child collection
      if (this.collection) {
        this.template = KbAdminItemWIthChildrenTemplate;
      } else {
        this.template = KbAdminItemTemplate;
      }
    },
    itemViewContainer: function () {
      return "#" + this.model.get("name") + "Menu";
    },
    className: function () {
      if (this.model === this.model.collection.activeItem) {
        return "active";
      }
      if (this.model.get("disabled")) {
        return "disabled";
      }
      if (this.model.get("className") == "divider") {
        return "divider";
      }
    },
    onCompositeRendered: function () {
      this.on("itemview:click:menu", function (view) {
        this.trigger("click:submenu", view, view.model);
      });
    },
    triggers: {
      "click .adminItem": "click:menu",
    },
    modelEvents: {
      change: "render",
    },
    close: function () {
      this.$el.find(".collapse").collapse("hide");
    },
    deselect: function () {
      this.$el.removeClass("active");
      this.$el.find(".active").removeClass("active");
    },
    setTabActive: function () {
      this.$el.find("a").first().tab("show");
      this.$el.find(".collapse").not(".in").collapse("show");
    },
  });

  KbAdminMenuView.menuView = Marionette.CompositeView.extend({
    template: KbAdminMenuTemplate,
    itemView: KbAdminMenuView.itemView,
    itemViewContainer: "ul",
  });

  return KbAdminMenuView;
});
